import { render, staticRenderFns } from "./DialogueQuestion.vue?vue&type=template&id=59672dac&scoped=true"
import script from "./DialogueQuestion.vue?vue&type=script&lang=js"
export * from "./DialogueQuestion.vue?vue&type=script&lang=js"
import style0 from "./DialogueQuestion.vue?vue&type=style&index=0&id=59672dac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59672dac",
  null
  
)

export default component.exports